import axios from 'axios';
import getApiUrl from 'src/utils/get-api-url';

const apiUrl = getApiUrl();

/**
 * Get all deallocationComments from one deallocation by id (uuid4).
 * 
 * @param {string} deallocationId 
 * @returns {Promise<Object>}
 */
export function get(deallocationId) {
  return axios.get(`${apiUrl}/deallocationComments/${deallocationId}`);
}

/**
 * Post a new comment on the deallocation.
 * 
 * @param {Object} comment
 * @param {string} comment.deallocationId
 * @param {string} comment.comment
 * @returns {Promise<Object>}
 */
export function add(comment) {
  return axios.post(`${apiUrl}/deallocationComments`, comment);
}

/**
 * Edit an existing comment on the deallocation.
 *
 * @param {Object} comment
 * @param {string} comment.id
 * @param {string} comment.deallocationId
 * @param {string} comment.comment
 * @returns {Promise<Object>}
 */
export function edit(comment) {
  return axios.put(`${apiUrl}/deallocationComments/${comment.id}`, comment);
}

/**
 * Delete a comment on the deallocation (soft delete).
 *
 * @param {string} commentId
 * @returns {Promise<Object>}
 */
export function remove(commentId) {
  return axios.delete(`${apiUrl}/deallocationComments/${commentId}`);
}
